import { get } from 'lodash';

function extraTableParams() {
  return {
    defaultSortField: 'name',
    defaultSortOrder: 'asc',
    hasCheckBox: true,
    isCheckable: true,
    isDetailed: false,
    rearrangeCols: false,
    toolBar: false,
    hideTableGutter: true,
    stickeyHeaders: true,
    customRowKey: 'uid',
  };
}

export default {
  modalBasics: [
    {
      label: 'col1',
      title: 'Shipment Details',
      fields: {
        genericFields: [
          {
            name: 'field-generic-input',
            label: 'Name',
            prop: 'name',
            placeHolder: 'Enter Name',
            isDisabled: true,
          },
          {
            name: 'field-generic-input',
            label: 'Project',
            prop: 'project.name',
            isDisabled: true,
          },
        ],
        dateFields: [
          {
            title: 'Ship Date',
            name: 'field-date',
            prop: 'delivery.deliveryStart',
            kind: 'dates',
            width: '15%',
            id: 'shipBy',
            inputProps: {
              kind: 'delivery.deliveryStart',
              max: 'delivery.deliverBy',
              disableEdit: true,
            },
          }, {
            title: 'Deliver Date',
            name: 'field-date',
            prop: 'delivery.deliverBy',
            kind: 'dates',
            width: '15%',
            id: 'deliverBy',
            inputProps: {
              kind: 'delivery.deliverBy',
              min: 'delivery.deliveryStart',
              disableEdit: true,
            },
          },
        ],
        multiGenericFields: [
          {
            name: 'field-generic-input',
            label: 'Name',
            prop: 'modalName',
            placeHolder: 'Enter Name',
            isDisabled: true,
            key: 'name'
          },
          {
            name: 'field-generic-input',
            label: 'Project',
            prop: 'project.name',
            isDisabled: true,
          },
        ],
      },
    },
  ],
  tableBasics: {
    ...extraTableParams(),
    fields: [
      {
        title: 'Item',
        name: 'field-generic-input',
        prop: 'name',
        width: '25%',
        id: 'name',
      },
      {
        title: 'Catalog',
        name: 'field-cat-id',
        prop: 'catId',
        width: '15%',
        id: 'catId',
      }, {
        title: 'Expected Quantity',
        name: 'available',
        prop: 'available',
        classRight: 'is-pulled-right',
        width: '15%',
        id: 'available',
      },
      {
        name: 'availableQty',
        title: 'Actual Quantity',
        visible: true,
        width: '12%',
      },{
        title: 'Issue',
        name: 'selectError',
        visible: true,
        width: '33%',
        id: 'selectedError',
      },
    ],
    hasCheckBox: false,
    isCheckable: false,
  },
  receiveDeliveries: {
    ...extraTableParams(),
    fields: [
      {
        title: 'Delivery',
        name: 'field-generic-input',
        prop: 'name',
        width: '40%',
        id: 'name',
        visible: true,
      },{
      name: 'shippingStatus',
      id: 'shippingStatus',
      title: 'Delivery Status',
      width: '160px',
      searchable: true,
      filterText: false,
      defaultVisible: true,
    }, {
        name: 'field-ship-items-icon',
        width: '64px',
        title: 'Items',
        defaultVisible: true,
        id: 'items',
        isDisabled: true,
        inputProps: {},
      },
      {
        title: 'Ship By',
        name: 'field-date',
        prop: '_delivery.deliveryStart',
        kind: 'dates',
        width: '152px',
        id: 'shipBy',
        inputProps: {
          kind: '_delivery.deliveryStart',
          max: '_delivery.deliverBy',
          disableEdit: false,
        },
      }, {
        title: 'Deliver By',
        name: 'field-date',
        prop: '_delivery.deliverBy',
        kind: 'dates',
        width: '152px',
        id: 'deliverBy',
        inputProps: {
          kind: '_delivery.deliverBy',
          min: '_delivery.deliveryStart',
          disableEdit: false,
        },
      },
    ],
  },
   getQrDeliveries: {
    ...extraTableParams(),
    fields: [
      {
        title: 'Delivery',
        name: 'field-generic-input',
        prop: 'name',
        width: '50%',
        id: 'name',
        visible: true,
      }, {
        title: 'Status',
        name: 'field-stage',
        prop: 'statusToShow',
        width: '196px',
        id: 'shippingStatus',
        isStatus: true,
      },
      {
        title: 'Ship By',
        name: 'field-date',
        prop: '_delivery.deliveryStart',
        kind: 'dates',
        width: '152px',
        id: 'shipBy',
        inputProps: {
          kind: '_delivery.deliveryStart',
          max: '_delivery.deliverBy',
          disableEdit: false,
        },
      }, {
        title: 'Deliver By',
        name: 'field-date',
        prop: '_delivery.deliverBy',
        kind: 'dates',
        width: '152px',
        id: 'deliverBy',
        inputProps: {
          kind: '_delivery.deliverBy',
          min: '_delivery.deliveryStart',
          disableEdit: false,
        },
      },
    ],
  },
};
